<template>
    <div class="kt-modal-wrap">
        <div 
            :id="props.id" 
            :class="['modal modal-wrap', { 'd-block': isVisible }]" 
            tabindex="-1" 
            ref="divModal" 
            v-if="isVisible"
        >
            <div class="modal-dialog" :class="props.size">
                <div class="modal-content">
                    <div class="modal-header" v-if="props.title || props.dismissable || slots.header">
                        <div 
                            v-if="props.title"
                            class="modal-title" 
                            v-html="props.title"
                        ></div>
                        <button 
                            v-if="props.dismissable"
                            type="button" 
                            class="btn-close" 
                            aria-label="Close"
                            @click="dismiss()"
                        ></button>
                        <slot name="header"></slot>
                    </div>
                    <div class="modal-body" v-if="props.body || slots.body">
                        <div b-html="props.body"></div>
                        <slot name="body"></slot>
                    </div>
                    <div 
                        v-if="slots.footer || props.buttons"
                        class="modal-footer">
                        <button 
                            v-for="btn in props.buttons"
                            type="button" 
                            :class="['btn', btn.css]"
                            @click="$emit('click', btn)"
                        >
                            <span v-html="btn.html"></span>
                            <span>{{ btn.text }}</span>
                        </button>
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, useSlots } from "vue";
// import * as bootstrap from 'bootstrap';

const slots = useSlots();
const divModal = ref(null);
const modal = ref(null);
const isVisible = ref(false);

const emit = defineEmits([
    "dismiss",
    "click"
]);

const props = defineProps({
    
    id: 
    {
        type: String,
        default() {
            return "kt-modal-" + 
                (Math.random() + "").replace(".", "") + 
                "-" + (+ new Date());
        }
    },

    visible: 
    {
        type: Boolean,
        default: false,
    },

    title: 
    {
        type: String,
        default: ""
    },

    size:
    {
        type: String,
        default: ""
    },

    dismissable: 
    {
        type: Boolean,
        default: true,
    },

    options: {
        type: Object,
        default: { 
            backdrop: "static", 
            keyboard: true, 
            focus: true 
        },
    },

});

const dismiss = () =>
{
    emit("dismiss");
    toggleModal(false);
};

const toggleModal = (show) =>
{
    if (typeof show !== "undefined")
    {   
        isVisible.value = !!show;
    }

    else
    {
        isVisible.value = !isVisible.value;
    }
}

const unwatch = watch(() => props.visible, toggleModal /*, { immediate: true } */);

onMounted(() =>
{    
    toggleModal(props.visible);
});

onUnmounted(() =>
{
    unwatch();
});

</script>

<style>

.kt-modal-wrap > .modal-wrap {
    background: rgba(0, 0, 0, 0.5);
}

</style>